/*
 * Messengers
 *
 * Listens for service-worker dispatched actions.
 * Use dispatch to communicate with the client.
 * Most common cases will trigger redux actions to update the client UI
 */

// service worker
import { API_ACTION, SW_ACTION } from 'app/client/workers/constants';

// actions
import AppActions from 'app/shared/actions/AppActions';
import PropertiesActions from 'app/shared/actions/PropertiesActions';

// model
import Listings from 'app/shared/model/Listings';

import analyticsUtils from 'app/client/utils/analyticsUtils';

const Receivers = (dispatch) => {
    if (navigator && navigator.serviceWorker) {
        navigator.serviceWorker.addEventListener('message', (event) => {
            const { action, payload } = event.data;
            const { ga, response, url } = payload;

            switch (action) {
                case API_ACTION.LISTINGS_UPDATE: {
                    const listingsModel = Listings(response);
                    dispatch(PropertiesActions.updateListings(listingsModel));
                    break;
                }

                // case does not update UI
                case SW_ACTION.DISPATCH: {
                    const { eventParams, label } = ga;

                    dispatch(analyticsUtils.track.GAEventV2(eventParams, { label }));
                    break;
                }

                case SW_ACTION.TRANSITION_TO: {
                    dispatch(AppActions.transitionTo(url));
                    break;
                }

                case SW_ACTION.UPDATE_LOCATION: {
                    dispatch(AppActions.updateLocation(url));
                    break;
                }

                default:
            }
        });
    }
};

export default Receivers;
